import { render, staticRenderFns } from "./blackPhone.vue?vue&type=template&id=0790a664&"
import script from "./blackPhone.vue?vue&type=script&lang=js&"
export * from "./blackPhone.vue?vue&type=script&lang=js&"
import style0 from "./blackPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports